module.exports = __webpack_public_path__ + "img/swipe.aaac37c4.svg";